'use client';

import NextButton from '@/components/Button/NextButton';
import Input from '@/components/Input/Input';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { fieldRules } from '@/utils/form';
import styles from './PreQualifiedForm.module.scss';

interface PreQualifiedModalData {
  confirmation: number;
  zipCode: string;
}

const PreQualifiedForm = () => {
  const searchParams = useSearchParams();
  const firstName = searchParams.get('firstName');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<PreQualifiedModalData>();
  const [pendingInfo, setPendingInfo] = useState({
    loading: false,
    error: '',
  });

  const onSubmit: SubmitHandler<PreQualifiedModalData> = async () => {
    setPendingInfo({ loading: false, error: '' });
  };

  return (
    <>
      <h6 className={styles.title}>Let&apos;s get started {firstName}</h6>
      <p className={styles.subtitle}>
        Please enter the confirmation code you received in your email.
      </p>
      <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
        <Input
          placeholder="Your confirmation #"
          label="Confirmation #"
          register={register('confirmation', {
            required: 'Field cannot be empty',
            pattern: {
              value: /^\d{5}$/,
              message: 'Enter your confirmation #',
            },
          })}
          error={errors.confirmation}
          type="number"
          id="secNumber"
        />
        <Input
          label="Zip code"
          placeholder="Your zip code"
          type="text"
          id="zip"
          register={register('zipCode', {
            ...fieldRules.zip,
            onChange: (e) => {
              const { target } = e;
              target.value = target.value.replace(/\D/g, '').slice(0, 5);
            },
          })}
          error={errors.zipCode}
        />
        <div className={styles.buttonsWrapper}>
          <NextButton
            type="button"
            buttonType="submit"
            text="View my offer"
            styles={styles.button}
            loading={pendingInfo.loading}
            disabled={pendingInfo.loading}
          />
          <NextButton
            type="button"
            buttonType="button"
            text="Don't have a code?"
            variation="transparent"
            styles={styles.button}
          />
        </div>
      </form>
    </>
  );
};

export default PreQualifiedForm;
